<template>
  <div class="footerPC">
    <div class="footerPC_body">
      <div class="footer_email">
        <!-- <img alt src="../assets/images/email.png"/> -->
        <span class="footer_email_font">Copyright © airdrop.ylem.network</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["black"],
  data() {
    return {
      imgList: [
        {
          tp: require("../../assets/images/crazy/footer_link1.png"),
          tp1: require("../../assets/images/crazy/footer_link1_s.png"),
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
          show: false,
        },
        {
          tp: require("../../assets/images/crazy/footer_link2.png"),
          tp1: require("../../assets/images/crazy/footer_link2_s.png"),
          url: "https://discord.com/invite/Vz9W3PeHyW",
          show: false,
        },
        {
          tp: require("../../assets/images/crazy/footer_link3.png"),
          tp1: require("../../assets/images/crazy/footer_link3_s.png"),
          url: "https://twitter.com/crzmarssquirrel",
          show: false,
        },
        // {
        //     tp:require('../../assets/images/crazy/footer_link4.png'),
        //     tp1:require('../../assets/images/crazy/footer_link4_s.png'),
        //     url:'https://t.me/+NSbg45u7FFE2YzAx',
        //     show:false,
        // }
      ],
    };
  },
  methods: {
    changeIndex(index) {
      this.imgList[index].show = !this.imgList[index].show;
    },
    changeIndexBack(index) {
      this.imgList[index].show = !this.imgList[index].show;
    },
  },
};
</script>

<style lang="scss" scoped>
.footerPC {
  width: 100%;
  // min-width: 1200px;
  background: #1f1f22;
  // border: 2px solid;

  .footerPC_body {
    width: 100%;
    height: 60px;
    display: flex;
    padding: 0px 0px;
    background: #1f1f22;
    .footerPC_body_left {
      width: 25%;
      // padding: 20px;
      line-height: 150px;
      text-align: center;
      display: flex;
      align-items: center;

      .footerPC_body_left_font1 {
        margin: 0px 0px 0 30px;
        width: auto;
        height: 17px;
        font-size: 16px;
        font-family: ArialMT;
        color: white;
        line-height: 18px;
        font-weight: 600;
      }

      .footerPC_body_left_font2 {
        margin: 0px 0px 0 30px;
        width: auto;
        height: 17px;
        font-size: 16px;
        font-family: ArialMT;
        color: white;
        line-height: 18px;
        font-weight: 600;
      }
    }
    .footerPC_body_center {
      width: 50%;
      // padding: 20px;
      line-height: 150px;
      text-align: center;
      display: flex;
      align-items: center;
      .footerPC_body_left_img {
        margin: 20px 0px 0 0;
        height: 130px;
        width: 100%;
        object-fit: contain;
      }
    }
    .footerPC_body_right {
      width: 20%;
      margin-left: 3%;
      height: 100%;
      display: flex;
      align-items: center;
      // display:inline-block;

      .footerPC_body_right3 {
        height: 100%;
        width: 33%;
        align-items: center;
        align-items: center;
        float: right;
        .footerPC_body_right_img1 {
          height: 100%;
          width: 100%;
          padding: 20px 38%;
          object-fit: contain;
        }
      }
    }
  }

  .footer_email {
    width: 100%;
    height: 60px;
    // background: #F9F9F9;
    text-align: center;
    padding: 0px 0 0 0;

    .footer_email_font {
      width: auto;
      height: 60px;
      font-size: 16px;
      font-family: ArialMT;
      color: white;
      line-height: 60px;
      margin: 0 0 0 7px;
    }
  }
}
</style>